import React from 'react';
import Dispatcher from '../dispatcher';
import UserStore from '../stores/user-store';
import UserAction from '../actions/user-action';
import UtilityStore from '../stores/utility-store';
import InlineSvg from '../utils/inline-svg';
import UtilityAction from '../actions/utility-action';

export default class Navigation extends React.Component {

  constructor() {
    super();
    this.state = {
      blah: Math.random(),
      user:  UserStore.get(),
      navigationOpen: UtilityStore.get(UtilityStore.HAMBURGER_STATE)
    };

    this._handleUserChange = this._handleUserChange.bind(this);
    this._handleHamburgerToggle = this._handleHamburgerToggle.bind(this);
  }

  componentDidMount() {
    Dispatcher.on(Dispatcher.USER_STORE_CHANGE, this._handleUserChange);
    Dispatcher.on(Dispatcher.HEADER_HAMBURGER_CHANGE, this._handleHamburgerToggle);
  }

  componentWillUnmount() {
    Dispatcher.removeListener(Dispatcher.USER_STORE_CHANGE, this._handleUserChange);
    Dispatcher.removeListener(Dispatcher.HEADER_HAMBURGER_CHANGE, this._handleHamburgerToggle);
  }

  _handleUserChange() {
    this.setState({ user: UserStore.get() });
  }

  _handleHamburgerToggle() {
    this.setState({ navigationOpen: UtilityStore.get(UtilityStore.HAMBURGER_STATE) });
  }

  _userInfoButton() {
    Routes.setRoute('/');
    Dispatcher.emit(Dispatcher.HEADER_HAMBURGER_OFF);
  }

  _devicesButton() {
    Routes.setRoute('devices');
    Dispatcher.emit(Dispatcher.HEADER_HAMBURGER_OFF);
  }

  _resourcesButton() {
    Routes.setRoute('resources');
    Dispatcher.emit(Dispatcher.HEADER_HAMBURGER_OFF);
  }

  _transactionsButton() {
    Routes.setRoute('transactions');
    Dispatcher.emit(Dispatcher.HEADER_HAMBURGER_OFF);
  }

  _bookshelfButton(e) {
    e.preventDefault();
    UtilityAction.openBookshelf();
  }

  _supportButton(e) {
    e.preventDefault();
    UtilityAction.openSupport();
  }

  _signOutButton() {
    UserAction.signOut();
  }

  _clickNavigationMask() {
    Dispatcher.emit(Dispatcher.HEADER_HAMBURGER_OFF);
  }

  _renderNavigationButton(id, callback){
    if (Mulligan.Brand.AccountCenter.Sidebar[id]){
      return (
        <li className={`${id}-button ${this.props.page === id ? "active" : ""}`}>
          <button className="vst-no-button"
                  onClick={callback}>
            <InlineSvg src={`${id}.svg`} />
            <span className="nav-text">{i18n.t(`base.${id}`)}</span>
          </button>
        </li>
      );
    }
  }

  render() {

    // Prevent errors when user is not yet loaded
    let firstName = this.state.user ? this.state.user.firstName : "";
    let lastName = this.state.user ? this.state.user.lastName : "";
    let email = this.state.user ? this.state.user.email : "";
    let ssoOnly = this.state.user && this.state.user.ssoOnly;

    return (
      <div id="content-left" className={classNames({'navigation-open': this.state.navigationOpen})}>
        {!ssoOnly &&
          <div className="user-info">
            <div className="user-info-header">
              <div className="name"><span>{firstName}</span> <span>{lastName}</span></div>
              <div className="email"><span>{email}</span></div>
            </div>
          </div>
        }
        <nav className="user-profile-menu">
          <ul>
            {!Mulligan.Brand.AccountCompletion.ssoOnly && this._renderNavigationButton('user', this._userInfoButton)}
            {this._renderNavigationButton('devices', this._devicesButton)}
            {this._renderNavigationButton('resources', this._resourcesButton)}
            {this._renderNavigationButton('transactions', this._transactionsButton)}
            {Mulligan.Brand.AccountCenter.Header.visible && [
              (Mulligan.Brand.Bookshelf.visible && 
                <li className={`bookshelf-button`}>
                  <div className="navigation-divider" />
                  <button className="vst-no-button"
                          onClick={this._bookshelfButton}>
                    <span className="inline-svg"><img role="presentation" src={require("../../img/circle_bookshelf_sm.svg")} /></span>
                    <span className="nav-text">{Mulligan.Brand.brand}</span>
                  </button>
                </li>
              ),
              Mulligan.Brand.Support.visible && (
                <li className={`support-button`}>
                  <button className="vst-no-button"
                          onClick={this._supportButton}>
                    <span className="inline-svg"><img role="presentation" src={require("../../img/circle_support_sm.svg")} /></span>
                    <span className="nav-text">{i18n.t('base.support')}</span>
                  </button>
                </li>
              ),
              <li className="sign-out-button">
                <div className="navigation-divider" />
                <button className="vst-no-button"
                        onClick={this._signOutButton}>
                  <InlineSvg src="sign_out.svg" />
                  <span className="nav-text">{i18n.t('base.sign-out')}</span>
                </button>
              </li>
            ]}
          </ul>
        </nav>
        <div className="navigation-mask" onClick={this._clickNavigationMask}></div>
      </div>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/js/components/navigation.jsx
 **/